import { createFileRoute } from '@tanstack/react-router';
import { Phone } from 'lucide-react';
import { createApplyPageHead } from '@/lib/seo';
import { loadPublicTemplate } from '@/lib/loadPublicTemplate';
import { SessionNotAvailable } from '@/components/SessionNotAvailable';

export const Route = createFileRoute('/apply/$publicId/call-success')({
  loader: async ({ params }) => loadPublicTemplate(params.publicId),
  head: ({ loaderData, params }) => {
    const vacancy = loaderData?.vacancy;
    const vacancyName = vacancy?.name || 'Job Application';
    const companyName = vacancy?.company_info?.name || 'Company';
    const companyLogo = vacancy?.company_info?.profile_image || undefined;

    return createApplyPageHead({
      vacancyName,
      companyName,
      companyLogo,
      publicId: params.publicId,
    });
  },
  component: CallSuccessComponent,
});

function CallSuccessComponent() {
  const { vacancy, unavailableReason } = Route.useLoaderData();

  if (!vacancy) {
    return <SessionNotAvailable reason={unavailableReason} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6 flex justify-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <Phone className="w-8 h-8 text-green-600" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Thank you for applying!
        </h1>
        <p className="text-gray-600">
          Our AI assistant will call you within the next few minutes to conduct
          your interview. Please keep your phone nearby and be ready to answer.
        </p>
      </div>
    </div>
  );
}
